<template>
    <div id="addProject">
        <!--elmentUi中dialog(对话框)中嵌套form（表单）-->
        <el-dialog title="项目信息" :visible.sync="dialogAdd.show" @close="closeDialog()" width="25%" center :modal-append-to-body='false'>
            <el-form :model="formData" ref="ruleForm"  label-width="80px">
                <el-form-item label="项目名称" prop="name">
                    <el-input v-model="formData.name"></el-input>
                </el-form-item>
                <el-form-item label="项目地址" prop="address">
                    <el-input v-model="formData.address"></el-input>
                </el-form-item>
                <el-form-item label="描述信息" prop="description">
                    <el-input v-model="formData.description"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAdd.show = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    export default {
        name: 'AddProject',
        props:{
            dialogAdd:Object //接受父组件传递给子组件的数据
        },
        data () {
            return {
                formData:{
                    name:'',
                    address:'',
                    description:''
                }
            }
        },
        methods:{
            closeDialog(){
                this.dialogAdd.show = false;
                this.formData = {};
            },
            submitForm(ruleForm) {
                this.$refs[ruleForm].validate((valid) => {
                    if (valid) {
                        this.$axios.post('api/monitor/project/createProject',this.formData).then(res => {
                            if(res.status == 200){
                                this.$message({
                                    type:"success",
                                    message: res.data.message,
                                    showClose: true
                                });
                                this.dialogAdd.show = false;
                                this.$emit('update'); //子组件使用$emit触发父组件自定义事件
                            }
                            return
                        });
                        this.formData  = {}
                    } else {
                        return false;
                    }
                })
            }
        }
    }
</script>

<style>
    #addProject .el-dialog__header {
      text-align: center;
        padding: 20px 30px 10px;
        /*background-image: url('../../assets/img/modal_bg.png')*/
      background: linear-gradient(
        -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
      border-radius: 2.5px 2.5px 0px 0px;
      transition: unset;
    }

    #addProject .el-dialog__body {
        padding: 10px 20px;
    }

    #addProject .el-dialog__title{
        font-size: 18px;
      text-align: center;
        color: #fff;
    }

</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/project/AddProject.vue